import { FC } from 'react';
import { TextBody, Stack, BlockList } from '@pypestream/design-system';
import ImgSupervisorKa from './supervisor-ka.svg?url';
import './supervisor-ka-info.scss';
import { TranslationComponent } from '@pypestream/translations';

export const SupervisorKaInfo: FC = () => (
  <div className="c-supervisor-ka-info">
    <img
      src={ImgSupervisorKa}
      alt=""
      className="c-supervisor-ka-info__cover-img"
    />
    <BlockList>
      <Stack nowrap gutter="xsmall">
        <span className="c-supervisor-ka-info__desc-number">A</span>
        <TextBody size="small">
          <b>Supervisor Agent:</b> This is the core of your application. It
          manages conversations, understands what a user needs, and
          intelligently routes them to the right workflows. It uses context to
          determine the best next step.
        </TextBody>
      </Stack>
      <Stack nowrap gutter="xsmall">
        <span className="c-supervisor-ka-info__desc-number">B</span>
        <TextBody size="small">
          <b>Automated Tasks & Workflows:</b> Execute structured automations and
          complex business workflows through Microagents, APIs, and system
          integrations.
        </TextBody>
      </Stack>
      <Stack nowrap gutter="xsmall">
        <span className="c-supervisor-ka-info__desc-number">C</span>
        <TextBody size="small">
          <b>Knowledge Agent:</b>{' '}
          <TranslationComponent i18nKey="pro-studio/homepage:vocabulary.ka_expert">
            This is your solution&#39;s expert. When
          </TranslationComponent>{' '}
          configured, it uses a RAG (Retrieval-Augmented Generation) engine to
          provide detailed, accurate answers. By referencing documents that you
          upload, it ensures responses are specific and relevant to your brand.
          It can also handle general conversation and chit-chat.
        </TextBody>
      </Stack>
    </BlockList>
  </div>
);
